import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { querySiteList, ajaxGetDictItems } from '@/api/api';
import { downloadFile, getAction, postAction, putAction } from '@/api/manage';
import moment from 'moment';
export default {
  data: function data() {
    return {
      moment: moment,
      dataTime: '',
      title: '',
      standardList: [],
      drawerVisible: false,
      userTree: [],
      reportObj: {
        dataTime: '',
        deviceRecordItemList: []
      },
      userId: [],
      tableArr: [{}],
      userInfo: {},
      statisticState: false,
      detailState: false,
      url: {
        exportXlsUrl: '/om/day/report/exportXls'
      },
      siteDict: [],
      dataDict: [],
      statusDict: []
    };
  },
  props: {},
  created: function created() {
    this.getDict('site_run_status', 'siteDict');
    this.getDict('date_transmission_status', 'dataDict');
    this.getDict('yes_no_status', 'statusDict');
  },
  mounted: function mounted() {
    this.userInfo = this.$store.getters.userInfo;
  },
  methods: {
    getDict: function getDict(code, name) {
      var _this = this;

      ajaxGetDictItems(code, null).then(function (res) {
        if (res.success) {
          _this[name] = res.result;
        }
      });
    },
    changeRun: function changeRun(value) {
      console.log('changeRun', value);
    },
    changeDataTime: function changeDataTime(value) {
      this.dataTime = value.format('YYYY-MM-DD');
    },
    add: function add() {
      this.reportObj = {
        dataTime: '',
        deviceRecordItemList: []
      };
      this.dataTime = '';
      this.drawerVisible = true;
      this.addState = true;
      this.detailState = false;
      this.title = '新增运维记录';
      this.getSite();
    },
    edit: function edit(record, data, state) {
      this.title = state ? '编辑运维记录' : '运维记录详情';
      this.drawerVisible = true;
      this.detailState = state;
      this.addState = false;
      this.dataTime = record.dataTime;
      record.deviceRecordItemList = data.deviceRecordItemList;
      this.reportObj = record;

      if (!this.detailState) {
        this.reportObj.dataTime = moment(this.reportObj.dataTime);
        this.reportObj.deviceRecordItemList.forEach(function (item, index) {
          item.controlTime = item.controlTime ? moment(item.controlTime) : '';
        });
        console.log('this.reportObj', this.reportObj);
      }
    },
    onOk: function onOk(value, item) {
      console.log('item', item); // item.controlTime = value.format('YYYY-MM-DD HH:mm:ss')
    },
    getSite: function getSite() {
      var _this2 = this;

      querySiteList().then(function (res) {
        if (res.success) {
          res.result.records.forEach(function (item, index) {
            _this2.reportObj.deviceRecordItemList.push({
              siteId: item.id,
              siteName: item.name,
              runState: '',
              transmission: '',
              controlWork: '',
              controlTime: '',
              firstTrial: '',
              handle: '',
              remark: ''
            });
          });
        }
      });
    },
    handleExportXls: function handleExportXls(fileName) {
      var that = this;

      if (that.reportObj.id) {
        that.queryParam.id = that.reportObj.id;
      }

      if (that.reportObj.userId) {
        that.queryParam.userId = that.reportObj.userId;
      }

      if (!fileName || typeof fileName != 'string') {
        fileName = that.pageTitle + '导出文件';
      }

      var param = _objectSpread({}, that.queryParam);

      if (that.selectedRowKeys && that.selectedRowKeys.length > 0) {
        param['selections'] = that.selectedRowKeys.join(',');
      }

      var url = that.url && that.url.exportXlsUrl ? that.url.exportXlsUrl : that.pagePath + '/exportXls';
      downloadFile(fileName + '.xls', url, param);
    },
    onSubmit: function onSubmit() {
      var _this3 = this;

      if (this.detailState) return;

      if (!this.reportObj.dataTime) {
        this.$message.warning('请选择日期');
        return;
      }

      console.log('reportObj', this.reportObj);
      console.log('dataTime', this.dataTime);
      var reportObj = Object.assign({}, this.reportObj);
      reportObj.dataTime = this.dataTime;
      reportObj.deviceRecordItemList.forEach(function (item, index) {
        delete item.siteName;

        if (item.controlTime) {
          item.controlTime = item.controlTime.format('YYYY-MM-DD HH:mm:ss');
        }
      });

      if (this.addState) {
        postAction('/om/device/record', reportObj).then(function (res) {
          if (res.success) {
            _this3.drawerVisible = false;

            _this3.$parent.loadData();
          }
        });
      } else {
        putAction('/om/device/record', reportObj).then(function (res) {
          if (res.success) {
            _this3.drawerVisible = false;

            _this3.$parent.loadData();
          }
        });
      }
    },
    onClose: function onClose() {
      console.log('res');
      this.drawerVisible = false;
    }
  }
};